<template>
  <el-dialog title="上传课件" :append-to-body="true" :visible.sync="visible" :show-close="false" width="55%" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click.stop="cancelModal"><i
      class="el-dialog__close el-icon el-icon-close"></i></button>
    <el-form :model="courseware" size="small" :rules="rules">
      <el-form-item label="标题" label-width="75px" prop="title">
        <el-input v-model="courseware.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="视频内容" label-width="75px" prop="content">
        <el-input type="textarea" v-model="courseware.content" autocomplete="off"></el-input>
      </el-form-item>
      <!--<el-form-item label="视频类型"  label-width="90px" prop="type">-->
        <!--<template>-->
          <!--<el-radio v-model="courseware.type" label="0">正式视频</el-radio>-->
          <!--<el-radio v-model="courseware.type" label="1">实习视频</el-radio>-->
        <!--</template>-->
      <!--</el-form-item>-->
      <el-form-item label="课件分类"  label-width="75px" prop="videotypeid">
        <el-select v-model="courseware.videotypeid" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="讲师姓名" label-width="75px" prop="name">
        <el-input v-model="courseware.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="讲师简介" label-width="75px">
        <el-input type="textarea" :rows="1" v-model="courseware.info" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="讲师照片" label-width="75px">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :http-request="uploadLecturerPhoto"
          :before-upload="beforeUpload"
          :file-list="tecList"
          list-type="picture">
          <div class="el-upload__text"><i class="el-icon-upload" style="font-size: 18px"></i><span>上传</span></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="内容图片" label-width="75px">
        <el-upload
          class="upload-demo"
          action="demo"
          :file-list="contentList"
          list-type="picture">
          <!--action="/_/video/uploadLecturerPhoto"-->
          <!--:on-success="upContentSuccess"-->
          <!--<div class="el-upload__text"><i class="el-icon-upload" style="font-size: 18px"></i><span>上传</span></div>-->
          <div slot="tip" class="el-upload__tip fr" style="color: #FF625B;margin: 0 0 0 5px">上传完视频后自动截图</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <el-form :model="attachment" size="small">
      <el-form-item label="附件" label-width="75px">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-change="handleChange"
          :on-remove="attRemove"
          :before-upload="attBeforeUpload"
          :file-list="attList">
          <div class="el-upload__text"><i class="el-icon-upload" style="font-size: 18px"></i><span>上传</span></div>
        </el-upload>
      </el-form-item>
      <el-form-item label="能否下载"  label-width="75px">
        <template>
          <!--<el-radio v-model="attachment.download" label="0">是</el-radio>-->
          <!--<el-radio v-model="attachment.download" label="1">否</el-radio>-->
          <el-radio-group v-model="attachment.download" @change="radioChange">
            <el-radio label="0">是</el-radio>
            <el-radio label="1">否</el-radio>
          </el-radio-group>
        </template>
      </el-form-item>
      <el-form-item label="视频" label-width="75px">
        <div v-if="courseware.id === null">
          需要先保存课件才能上传视频
        </div>
        <template v-else>
          <template v-if="courseware.files.length > 0 && imgFlag == false">
            <div  v-for="(item,index) in courseware.files" :key="item.id" style="width:170px;margin-right:10px;float: left">
              <span v-if="item.status === 'z'">
                <el-tooltip class="item" effect="dark" content="正在转码。。" placement="top-start">
                <i class="el-icon-refresh-left" style="font-size: 20px;color:#fff;position: absolute;top: 5px;right: 5px;z-index: 999;"></i>
                </el-tooltip>
              </span>
              <span v-if="item.status === 'n'">
                <el-tooltip class="item" effect="dark" content="转码失败，请点击重试" placement="top-start">
                <i class="el-icon-refresh-left" @click="manualTranscoding(item.id)" style="font-size: 20px;color:#fff;position: absolute;top: 5px;right: 5px;z-index: 999;"></i>
                </el-tooltip>
              </span>
              <video v-if="item.mediaUrl" :id="'player-container' + index" width="170" height="95" ></video>
              <video v-else  controls="controls" :src="[oldUrl + item.addressAfterConversion]" class="avatar">
              </video>
            </div>
        </template>
        <el-upload
          class="avatar-uploader"
          :data="paramsdata"
          action="/_/video/upload"
          :headers="myHeaders"
          :on-error="handleError"
          :on-success="handleSuccessVideo"
          :on-progress="uploadProcess"
          :before-upload="videoBeforeUpload"
          :on-remove="handleRemove"
          :file-list="videoList">
          <!--<div class="el-upload__text"><i class="el-icon-upload"></i><em>视频上传</em></div>-->
          <!--<video v-if="imageUrl.length > 1 && imgFlag == false"  controls="controls" :src="[url + imageUrl]" class="avatar"></video>-->
          <!--<i v-if="imageUrl.length < 0 && imgFlag == false" class="el-icon-plus avatar-uploader-icon"></i>-->
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <!--<el-progress v-if="imgFlag == true" type="circle" :percentage="percent" width="55" stroke-width="4" style="margin-top: 20px"></el-progress>-->
        </el-upload>
        </template>
        <!--<el-dialog :visible.sync="dialogVisible" :modal="false">-->
          <!--<video controls="controls" :src="[url + imageUrl]" class="avatar"></video>-->
        <!--</el-dialog>-->
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="loading" type="primary" :loading="true">保存中</el-button>
      <el-button v-else type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import store from '../../../store/index'
import courseware from '@/api/courseware'
import attachment from '@/api/attachment'
import video from '@/api/video'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    values: {
      type: Number,
      required: false,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      radioStatus: false,
      players: [],
      myHeaders: {Authorization: null},
      // url: 'http://192.168.3.67:10001/lawyer/',
       oldUrl: 'http://v.hnlawyer.org/',
      url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/',
      showVideo: false,
      tecList: [],
      attList: [],
      videoList: [],
      contentList: [],
      param: '',
      photoParam: '',
      paramsdata: {
        type: 'C',
        cId: null
      },
      fileName: '',
      cid: 0,
      options:[],
      // 课件
      courseware: {
        id: null,
        name: null,
        info: null,
        videotypeid: null,
        title: null,
        photo: null,
        img: null,
        // files: '',
        type: '0',// 视频类型 0=正式视频，1=实习视频
        content: null,
        liveStatus: null,
        status: '1'
      },
      rules: {
        title: [
          {required: true, message: '请输入直播标题', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入讲师姓名', trigger: 'blur'},
        ],
        content: [
          {required: true, message: '请输入直播内容', trigger: 'blur'},
        ],
        // type: [
        //   {required: true, message: '请选择视频类型', trigger: 'change'},
        // ],
        videotypeid: [
          {required: true, message: '请选择视频分类', trigger: 'change'},
        ]
      },
      // 附件
      attachment: {
        id: 0,
        liveId: 0,
        download: '0',
        name: '',
        path: '',
        status: '1'
      },
      imgFlag: false,
      imageUrl: [],
      player:null,
      percent: 0,
      dialogImageUrl: '',
      dialogVisible: false,
      listObj: {},
      dataObj: { token: '111o8CXprRY-dhCawNZM7LQMNs-4y1pEmUlzbuMExv9:Xqu54BdpgEykaYpZf4IKGJQpaNc=:eyJzY29wZSI6ImIyZXJwIiwiZGVhZGxpbmUiOjE1NjAyMTkxMDB9' } // 此处token写成常量方便调试，正式环境需要获取token
    }
  },
  created() {
    console.log('')
    this.myHeaders.Authorization = 'Bearer '+store.getters.getToken
    this.getCoursewareType()
    this.reload()
  },
  methods: {
    initForm () {
      this.courseware = {
        id: 0,
        title: null,
        name: null,
        info: null,
        photo: null,
        img: null,
        content: null,
        liveStatus: null,
        status: '1'
      }
      if (this.$refs.courseware) {
        this.$refs.courseware.resetFields()
      }
    },
    initVideo(arr) {
      const licenseUrl = 'https://license.vod2.myqcloud.com/license/v2/1333755895_1/v_cube.license'
      arr.forEach((item, index) => {
        if (item.mediaUrl) {
          let sources = []
          sources.push({
            src: item.mediaUrl
          })
          const player =  this.TCPlayer('player-container' + index, {
            sources,
            licenseUrl,
            width: 170,
            height:95
          });
          this.players.push(player);
        }

      })
    },
    cancelModal () {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit('update:visible', false)
       if (this.players && this.players.length) {
        this.players.forEach(player => {
          player.dispose(); // 调用dispose方法来销毁播放器实例
        });
        this.players = []; // 清空引用数组，防止内存泄漏
      }
    },
    // 获取课件所属分类
    getCoursewareType () {
      courseware.findAllType({name: ''}).then(res => {
        if (res.data.code === 0){
          this.options = []
          res.data.data.forEach(item => {
            let obj = {
              label: item.name,
              value: item.id
            }
            this.options.push(obj)
          })
        }
      })
    },
    reload () {
      if (this.values !== null) {
        // 根据liveid查找课件详情
        courseware.load({ id: this.values }).then(res => {
          this.courseware = res.data.data
          // console.log(res.data.data)
          this.paramsdata.cId = this.values
          //回显视频
          this.$nextTick(() => {
             this.initVideo(this.courseware.files)
          })


          // console.log(this.courseware.files)
          this.courseware.files.forEach((item, i, arr) => {
            let upLoadImg = {
              id: item.id,
              name: item.addressAfterConversion,
              url: item.addressAfterConversion,
              status: item.signOfSuccess
            }
            this.videoList.push(upLoadImg)
            this.imageUrl.push(upLoadImg)
          })
          // this.imageUrl = this.courseware.files
          //回显讲师照片
          if (this.courseware.photo) {
            this.tecList = []
            let upLoadImg = {
              name: this.courseware.name,
              url: this.url + this.courseware.photo
            }
            this.tecList.push(upLoadImg)
          }
          // 回显内容照片
          if (this.courseware.img) {
            this.contentList = []
            let upLoadImg = {
              name: this.courseware.img,
              url: this.courseware.coverUrl || this.oldUrl + this.courseware.img
            }
            this.contentList.push(upLoadImg)
          }
        })
        // 附件详情
          attachment.find({liveId: this.values, type: 'C'}).then(res => {
            if (res.data.code === 0 && res.data.data.length > 0) {
              this.attachment.download = res.data.data[0].download
              let list = res.data.data
              this.attList = []
              list.forEach((item, i, arr) => {
                let upLoadImg = {
                  id: item.id,
                  name: item.name,
                  url: this.url + item.path
                }
                this.attList.push(upLoadImg)
            })
          }
        })
      }
    },
    save () {
      this.loading = true
      // 新增
      if (this.courseware.id == null){
        // 添加附件
        if (this.fileName !== '') {
          // console.log(this.courseware)
          courseware.save(this.courseware).then(res => {
            this.loading = false
            // console.log(res.data.data)
            // this.$message.info(res.data.message)
            if (res.data.code===0){
              //保存附件
              this.attList.forEach(file => {
                this.param.append('file', file.raw)
              })
              this.param.append('download', this.attachment.download)
              this.param.append('liveId', res.data.data)
              attachment.upload(this.param).then(resust => {
                if (resust.data.code===0){
                  this.$message.success('保存成功')
                  this.$emit('update:visible', false)
                  this.$emit('callFather')
                }else {
                  this.$message.info('保存失败')
                }
              })
            }
          })
        }else {
          // 没有附件
          courseware.save(this.courseware).then(res => {
            this.loading = false
            this.$message.info(res.data.message)
            if (res.data.code===0){
              this.$emit('callFather')
              this.$emit('update:visible', false)
            }
          })
        }
      } else {
        // 修改
        if (this.fileName !== '') {
          // console.log(this.courseware)
          courseware.save(this.courseware).then(res => {
            this.loading = false
            // this.$message.info(res.data.message)
            if (res.data.code===0){
              //保存附件
              this.attList.forEach(file => {
                if (file.hasOwnProperty('raw')) {
                  this.param.append('file', file.raw)
                }
              })
              this.param.append('download', this.attachment.download)
              this.param.append('liveId', this.courseware.id)
              attachment.upload(this.param).then(resust => {
                if (resust.data.code===0){
                  this.$message.success('保存成功')
                  this.$emit('update:visible', false)
                  this.$emit('callFather')
                }else {
                  this.$message.info('保存失败')
                }
              })
            }
          })
        }else {
          // 没有附件
          courseware.save(this.courseware).then(res => {
            this.loading = false
            if (res.data.code===0){
              this.$message.success(res.data.message)
              this.$emit('callFather')
              this.$emit('update:visible', false)
            }else {
              this.$message.error(res.data.message)
              return
            }
          })
          // 如果监听到是否下载数据变动，需要修改
          if (this.radioStatus){
            this.param = new FormData();
            this.param.append('file', null)
            this.param.append('liveId', this.courseware.id)
            this.param.append('download', this.attachment.download)
            // console.log(this.param)
            attachment.upload(this.param).then(resust => {
              if (resust.data.code===0){
                this.$emit('update:visible', false)
                this.$emit('callFather')
              }
            })
          }
        }
      }
    },
    // 上传讲师照片
    beforeUpload(file) {
      // console.log(file);
      //重新写一个表单上传的方法
      this.photoParam = new FormData();
      this.photoParam.append('file', file, file.name)
      // return false;
    },
    uploadLecturerPhoto () {
      video.uploadPhoto(this.photoParam).then(res => {
        if (res.data.code===0){
          this.$message.success('图片保存成功')
          let photoUrl = res.data.data
          photoUrl = photoUrl.replace(/\\/g,'/')
          // console.log(photoUrl)
          var index = photoUrl.lastIndexOf("/");
          let name = photoUrl.substring(index+1,photoUrl.length);
          let upLoadImg = {
            name: name,
            url: this.url + photoUrl
          }
          this.tecList.push(upLoadImg)
          this.courseware.photo = photoUrl
        }else {
          this.$message.info('图片保存失败')
        }
      })
    },
    // 上传内容图片
    // upContentSuccess(response, file, contentList) {
    //   console.log(contentList)
    //   let self = this;
    //   if (response.code === 0) {
    //     if(this.upLoadImg){
    //       this.$message({
    //         showClose: true,
    //         message: '上传成功！',
    //         type: 'success'
    //       });
    //     }
    //     let upLoadImg = {
    //       name: file.name,
    //       url: 'http://learn.hnlawyer.org' + response.data
    //     }
    //     this.contentList.push(upLoadImg)
    //     this.courseware.photo = response.data
    //   } else {
    //     //上传失败清空上传列表
    //     this.$message({
    //       showClose: true,
    //       message: response.msg,
    //       type: 'error'
    //     });
    //   }
    // },
    // 删除视频
    handleRemove(file, fileList) {
      // console.log(file)
      // console.log(fileList)
      // 页面数据
      if (file.hasOwnProperty('response')) {
        // console.log('删除刚上传的视频')
        // console.log(file)
        courseware.delByVideoId({id: file.response.data.id}).then(res => {
          this.$message.info(res.data.message)
          if (res.data.code=== 0){
            this.imageUrl.forEach((item, i, arr) => {
              if (file.response.data.id === item.id){
                // console.log(item)
                this.imageUrl.splice(i,1)
                // this.imageUrl.remove(item)
              }
            })
          }
        })
      }else {
        // 删除回显的视频
        // console.log('删除回显的视频')
        // console.log(file)
        courseware.delByVideoId({id: file.id}).then(res => {
          this.$message.info(res.data.message)
          if (res.data.code===0){
            this.imageUrl.forEach((item, i, arr) => {
              if (file.url === item.url){
                // console.log(item)
                this.imageUrl.splice(i,1)
                // this.imageUrl.remove(item)
              }
            })
          }
        })
      }
    },
    handleSuccessVideo(response) {
      // console.log(123, response);
      this.imgFlag = false;
      this.percent = 0;
      if (response.code===0) {
        // this.imageUrl = response.data;
        let obj = {
          url: response.data.addressAfterConversion,
          id: response.data.id,
          status: response.data.signOfSuccess
        }
        this.imageUrl.push(obj)
        // this.showVideo = true
        // this.courseware.files = response.data
        this.$message.success(response.message);
      } else {
        this.$message.error('视频上传失败，请重新上传！');
      }
    },
    // handlePictureCardPreview(file) {
    //   console.log(file)
    //   this.imageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    handleError(err, file, fileList) {
      // 上传失败异常处理
      const error = JSON.parse(JSON.stringify(err));
      // console.log(err)
      // console.log(error)
      this.$message.error(error.status.toString());
      this.imgFlag = false;
      this.percent = 0;
    },
    videoBeforeUpload(file) {
      // console.log(file);
      // console.log(file.type);
      var fileName = file.name || ''
      var ext = fileName.split(".")[fileName.split(".").length - 1];
      // console.log(ext)
      // const _self = this;
      const isVideo = file.type === 'video/mp4' || file.type === 'video/ogg' || file.type === 'video/avi' || file.type === 'video/x-matroska' || file.type === 'video/wmv' || file.type === 'video/mpeg' || file.type === 'video/rmvb';
      // const isLt30M = file.size / 1024 / 1024 < 30;
      if (!isVideo && ext!=='flv') {
        this.$message.warning('请上传正确格式的视频！');
        return false;
      }
    },
    // uploadVideo () {
    //   video.upload(this.param).then(res => {
    //     // alert(res.data.message)
    //     // if (res.data.code===0){
    //     //   this.$message.success('图片保存成功')
    //     //   let photoUrl = res.data.data
    //     //   photoUrl = photoUrl.replace(/\\/g,'/')
    //     //   console.log(photoUrl)
    //     //   var index = photoUrl.lastIndexOf("/");
    //     //   let name = photoUrl.substring(index+1,photoUrl.length);
    //     //   let upLoadImg = {
    //     //     name: name,
    //     //     url: 'https://lx-1333755895.cos.ap-guangzhou.myqcloud.com/' + photoUrl
    //     //   }
    //     //   this.tecList.push(upLoadImg)
    //     //   this.courseware.photo = photoUrl
    //     // }else {
    //     //   this.$message.info('图片保存失败')
    //     // }
    //   })
    // },
    // 上传进度
    uploadProcess(event, file, fileList) {
      // this.imgFlag = true;
      // console.log(event.percent);
      // this.percent = Math.floor(event.percent);
    },
    // 附件上传
    handleChange(file, fileList) {
      // console.log(file.raw);
      this.attList = fileList.slice(-3);
    },
    attRemove(file, attList) {
      // console.log(file, attList);
      // 从数据库中删除
      if (file.hasOwnProperty('id')){
        attachment.del({id: file.id}).then(res => {
          this.$message.info(res.data.message)
        })
      }
    },
    //阻止upload的自己上传，进行再操作
    attBeforeUpload(file) {
      // console.log(file);
      this.fileName = file.name
      //重新写一个表单上传的方法
      this.param = new FormData();
      // this.param.append('name', file.name)
      this.param.append('type', 'C')
      return false;
    },
    //覆盖默认的上传行为
    httprequest() {
    },
    // 手动转码
    manualTranscoding (id) {
      // console.log(id)
      courseware.manualTranscoding({id: id}).then(res => {
        this.$message.info(res.data.message)
      })
    },
    radioChange () {
      this.radioStatus = true
    }
  },
}
</script>
<style>
  .video-js{
    width: 170px;
    height: 95px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
    width: 170px;
    height: 95px;
    line-height: 95px;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 170px;
    height: 95px;
    line-height: 95px;
    text-align: center;
  }

  .avatar {
    width: 170px;
    height: 95px;
    display: block;
  }

  .image-preview {
    width: 178px;
    height: 178px;
    position: relative;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    float: left;
  }

  .image-preview .image-preview-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .image-preview .image-preview-wrapper img {
    width: 100%;
    height: 100%;
  }

  .image-preview .image-preview-action {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s;
    cursor: pointer;
    text-align: center;
    line-height: 200px;
  }

  .image-preview .image-preview-action .el-icon-delete {
    font-size: 32px;
  }

  .image-preview:hover .image-preview-action {
    opacity: 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/video/courseware/Courseware.vue